import axios, { AxiosResponse, AxiosError } from "axios";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const storedUserDetails = localStorage.getItem("userdetails");
const token = storedUserDetails ? JSON.parse(storedUserDetails).token.replace(/^"(.*)"$/, '$1') : null;

export const getInstitutions = (
  per_page_records: any,
  page_number: any,
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");


  axios
    .get(`${global.stms_url}/institutions?page_number=${page_number}&per_page_records=${per_page_records}`)
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack(response.data);
      }
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 400 || error.response?.status === 404) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 401) {
        localStorage.clear();
      } else {
        toast.error("Server Error");
        _errorCallBack(error);
      }
    });
};
 export const addInstitution = (institution_name:any,address:any,latitude:any,longitude:any,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
    ) => {
      const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
      const headers = {
        Authorization: `Bearer ${userDetailsFromStorage.token}`, 
      };
      const payload = {
        institution_name,
        address,
        latitude,
        longitude
      };
    axios
      .post(`${global.stms_url}/institutions`, payload)
      
      .then((response: AxiosResponse) => {
        if (response.status === 200 || response.status === 201) {
          _successCallBack(response.data);
        } else {
          _errorCallBack("Unexpected status code: " + response.status);
        }
      })
      .catch((error: AxiosError) => {
          console.log('Error caught:', error);
          if (error.response?.status === 400) {
            _errorCallBack(error.response.data);
          } else if (error.response?.status === 404) {
              console.log(error.response.data);
            _errorCallBack(error.response.data);
          }else if (error.response?.status === 409) {
            _errorCallBack(error.response.data);
          } else if (error.response?.status === 401) {
            localStorage.clear();
          } 
else
  {_errorCallBack("Server Error");}
        });
  };
  export const editInstitutions = (
     id:any,
     institution_name:any,    
     address:any,
     latitude:any,
     longitude:any,     
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
  ) => {
    const payload = {
      institution_name,
      address,
      latitude,
      longitude
  
    
    };
    axios
      .put(`${global.stms_url}/institutions/${id}`, payload)
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data); 
        }
        else if(response.status === 201) {
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data); 
        } 
        else if (error.response?.status === 404) {
          _errorCallBack(error.response.data);
        }else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else{
          toast.error("Server Error");
        }
      });
  };
  export const deleteInstitutions = (
    id: any,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void
  ) => {

    axios
      .delete(`${global.stms_url}/institutions/${id}`)
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 200) {
          _successCallBack(response.data);
        } 
      })
      .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        } else if (error.response?.status === 401) {
          localStorage.clear();
          toast.error("Login Expired.");
        }  else if( error.response?.status === 404)
          {
            _errorCallBack(error?.response?.data);
          }
        else {
          toast.error("Server Error");
        }
      });
  };
  
